import { useEnterprisePermittedProducts } from 'bundles/unified-common/contexts/EnterprisePermittedProductsContext';
import { useIsWildcard } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

const useIsLimitedContent = () => {
  const isOrgScopedHome = useIsOrgScopedHome();
  const isWildcard = useIsWildcard(); // program level full catalog
  const enterprisePermittedProducts = useEnterprisePermittedProducts(); // org level limitation

  return enterprisePermittedProducts?.isProgramLimitedContent || (!isOrgScopedHome && !isWildcard);
};

export default useIsLimitedContent;
